import { Component } from '@angular/core';
import { Option } from '../../../models/option.model';
import { SimpleExcelUploadComponent } from '../../../components/abstract/simple/simple-excel-upload.component';
import { ExcelData } from '../../../models/excel-data.model';
import { Validators } from '@angular/forms';

@Component({
  selector: 'app-example-upload',
  templateUrl: './example-upload.component.html',
  styleUrls: ['./example-upload.component.scss']
})
export class ExampleUploadComponent extends SimpleExcelUploadComponent {

  override componentClassName: string = 'ExampleUploadComponent';

  // 預設是 30 MB，可以 override 自行設定
  override maxFileSize: number = 10;

  // sheetName 下拉選單
  sheetNameOptions: Option[] = [];

  override initFormGroup(): void {
    console.log('ExampleFormComponent initFormGroup');

    this.formGroup = this.formBuilder.nonNullable.group({
      fileName: ['', [this.fileSizeValidator(), Validators.required]],
      sheetName: ['', Validators.required ]
    });
  }

  override initFormControlDisabled(): void {
    return;
  }

  override initStaticOptions(): void {
    return;
  }

  override async initFormData(): Promise<any> {
    return;
  }

  override afterLangChange(): void {
    return;
  }

  override afterFormDataLoadSuccess(): void {
    return;
  }

  override afterFormDataLoadFail(): void {
    return;
  }

  override afterFileParseSuccess(result: ExcelData): void {
    // 設定 sheetname 下拉選單
    this.sheetNameOptions = result.sheetNameOptions;

    this.formGroup.patchValue({
      'fileName': result.fileName,
      'sheetName': result.sheetNameOptions[0].value
    });
  }

  override afterFileParseFail(): void {
    this.sheetNameOptions = [];
    this.formControl('fileName').reset();
    this.formControl('sheetName').reset();
  }

  upload(): void {
    this.submitted = true;
    if (this.formGroup.valid) {
      this.systemMessageService.info('按下上傳按鈕');
    }
  }
}
